import { Component, DestroyRef, inject, OnInit, input, output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';

import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-htx-dialog',
  imports: [
    FormsModule,
    MatButton,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    ReactiveFormsModule,
    TranslocoPipe,
    TranslocoDirective,
    MatProgressSpinner
  ],
  templateUrl: './htx-form-dialog.component.html'
})
export class HtxFormDialogComponent implements OnInit {
  readonly formGroup = input.required<FormGroup>();
  readonly titleKey = input<string>('');
  readonly isInitialized = input<boolean>(false);
  readonly formSubmit = output<void>();
  readonly formCancel = output<void>();
  readonly destroyRef = inject(DestroyRef);

  /**
   * Action as observable to safe change detection and be able to combine
   * this action more smoothly with other observables.
   */
  cancel$ = new Subject<void>();
  save$ = new Subject<void>();

  ngOnInit() {
    this.save$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.formSubmit.emit();
    });

    this.cancel$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.formCancel.emit();
    });
  }
}
